import {
	COMMON_IMAGE,
	CURSOR,
	drawExpansionIcon,
	drawRectangle,
	getTextColor,
	getTrimmedText,
	GROUP_SECTION_PADDING_LEFT,
	GROUP_SECTION_SPACING_LEVEL_FOUR,
	GROUP_SECTION_WIDTH,
	GROUP_TYPE,
	GROUP_SECTION_PADDING_LEFT_SMALL,
	GROUP_SECTION_TEXT_GREY_LIGHT,
	EXPAND_ICON_WIDTH,
	drawBorder,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_ACTION_BUTTON_SIZE,
	GROUP_SECTION_EXPAND_ICON_WIDTH,
	GROUP_SECTION_EXPAND_ICON_HEIGHT,
} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class TaskGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_TASK, data);
		if (data.subTaskLevel === undefined) {
			data.subTaskLevel = 0;
		}
	}

	addSubTaskLevel(subTaskLevel){
		this.data.subTaskLevel = subTaskLevel;
		if(this.data.groups){
			this.data.groups.forEach(group => {
				group.addSubTaskLevel(subTaskLevel + 1);
			})
		}
	}

	refreshData(updatedTask) {
		this.data.name = updatedTask.name;
	}

	draw(canvasContext, x, y) {
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, groupType, expanded} = this;
			super.draw(x, y, width, height, this);
			const {name, id, color, isInProjectGroup, projectGroupColor} = data;
			const cacheId = `${groupType}-${id}`;
			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);
			const taskDone = data.task.done;
			const borderThickness = 1;
			const connectedProjectOffset = isInProjectGroup ? GROUP_SECTION_PADDING_LEFT : 0;

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			// draw left connected project border color
			if (isInProjectGroup && projectGroupColor) {
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH,
					y - 2 - (borderThickness * 2),
					height + (borderThickness * 2),
					true,
					projectGroupColor,
					GROUP_SECTION_PROJECT_BORDER_WIDTH,
				);
			}

			const fontSize = 11;
			const textColor = getTextColor();

			const drawGroup = () => {
				const subTaskLevelOffset = data.subTaskLevel * GROUP_SECTION_PADDING_LEFT;
				const topBottomBorderThickness = 1;
				const smallestTaskOffsetX = GROUP_SECTION_SPACING_LEVEL_FOUR + (GROUP_SECTION_PADDING_LEFT * 2) + GROUP_SECTION_PADDING_LEFT_SMALL + EXPAND_ICON_WIDTH;
				const maxNameWidth = GROUP_SECTION_WIDTH() - connectedProjectOffset - smallestTaskOffsetX - subTaskLevelOffset - GROUP_SECTION_PADDING_LEFT - GROUP_SECTION_ACTION_BUTTON_SIZE;

				drawRectangle(
					canvasContext,
					x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_FOUR + subTaskLevelOffset,
					y - 1,
					width - GROUP_SECTION_SPACING_LEVEL_FOUR - subTaskLevelOffset,
					height + 1
				);

				// right project colored border
				if (!isInProjectGroup) {
					drawBorder(
						canvasContext,
						x + width - GROUP_SECTION_PROJECT_BORDER_WIDTH,
						y - 2 - (topBottomBorderThickness * 2),
						height + (topBottomBorderThickness * 2),
						true,
						color,
						GROUP_SECTION_PROJECT_BORDER_WIDTH,
					);
				}

				if (data.expandable) {
					canvasContext.drawImage(
						cacheManager.getCommonImage(expanded ? COMMON_IMAGE.EXPAND_GROUP_ICON : COMMON_IMAGE.EXPAND_GROUP_CLOSED_ICON),
						x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_FOUR + subTaskLevelOffset - (GROUP_SECTION_EXPAND_ICON_WIDTH / 2),
						y + (height / 2) - (GROUP_SECTION_EXPAND_ICON_HEIGHT / 2),
						GROUP_SECTION_EXPAND_ICON_WIDTH,
						GROUP_SECTION_EXPAND_ICON_HEIGHT,
					);
				}

				// task icon
				const iconHeight = 16;
				const iconWidth = 16;
				const taskIcon = data.subTaskLevel > 0
					? taskDone
						? COMMON_IMAGE.TASK_DONE_BLACK
						: data.isStarted
							? COMMON_IMAGE.SUB_TASK_BLACK
							: COMMON_IMAGE.SUB_TASK_NOT_STARTED
					: taskDone
						? COMMON_IMAGE.TASK_DONE_BLACK
						: data.isStarted
							? COMMON_IMAGE.TASK_BLACK
							: COMMON_IMAGE.TASK_NOT_STARTED
				canvasContext.drawImage(
					cacheManager.getCommonImage(taskIcon),
					x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_FOUR + GROUP_SECTION_PADDING_LEFT + (GROUP_SECTION_EXPAND_ICON_WIDTH / 2) + subTaskLevelOffset,
					y + (height / 2) - (iconHeight / 2),
					iconWidth,
					iconHeight,
				);

				// task name
				canvasContext.fillStyle = data.isStarted ? textColor : GROUP_SECTION_TEXT_GREY_LIGHT;
				canvasContext.font = `600 ${fontSize}px ` + Util.getFontFamily();
				const nameTrimmed = getTrimmedText(canvasContext, name, maxNameWidth);
				canvasContext.fillText(
					nameTrimmed,
					x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_FOUR + (GROUP_SECTION_PADDING_LEFT * 2) + GROUP_SECTION_PADDING_LEFT_SMALL + EXPAND_ICON_WIDTH + subTaskLevelOffset,
					y + (height / 2) + (fontSize / 3)
				);

				// task done name strikethrough
				if (taskDone) {
					const strikethroughPadding = 4;
					drawRectangle(
						canvasContext,
						x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_FOUR + (GROUP_SECTION_PADDING_LEFT * 2) + GROUP_SECTION_PADDING_LEFT_SMALL + EXPAND_ICON_WIDTH + subTaskLevelOffset - (strikethroughPadding / 2),
						y + (height / 2),
						canvasContext.measureText(nameTrimmed).width + strikethroughPadding,
						0.75,
						{
							backgroundColor: textColor,
						}
					);
				}
			};
			drawGroup();
		} else {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, groupType, expanded} = this;
			super.draw(x, y, width, height, this);
			const {name, id, companyTaskId} = data;
			const cacheId = `${groupType}-${id}`;
			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			const textColor = getTextColor();

			const drawGroup = () => {
				const subTaskLevelOffset = data.subTaskLevel * 10;
				const xOffset = data.isInProjectGroup ? 16 : 10;
				drawRectangle(canvasContext, x + xOffset, y - 1, width - xOffset, height + 1, {
					borderColor: '#ebebee',
					borderThickness: 1,
				});

				if (data.expandable) {
					drawExpansionIcon(canvasContext, x, y, width, height, {
						expanded,
					});
				}

				canvasContext.fillStyle = data.isStarted ? textColor : '#a1a1a1';
				canvasContext.font = '500 12px ' + Util.getFontFamily();
				canvasContext.fillText(getTrimmedText(canvasContext, name, data.task.done ? 160 : 180), x + 64 + subTaskLevelOffset, y + 18);
				canvasContext.fillStyle = '#a1a1a1';
				canvasContext.font = '700 10px ' + Util.getFontFamily();
				canvasContext.fillText(`T${companyTaskId}`, x + 24 + subTaskLevelOffset, y + 17);
				if (data.task.done) {
					const xExpanderOffset = data.expandable ? 30 : 0;
					canvasContext.strokeStyle = '#00cc66';
					canvasContext.lineWidth = 2;
					canvasContext.beginPath();
					canvasContext.moveTo(x + 244 - xExpanderOffset, y + 15);
					canvasContext.lineTo(x + 248 - xExpanderOffset, y + 19);
					canvasContext.lineTo(x + 257 - xExpanderOffset, y + 8);
					canvasContext.stroke();
					canvasContext.lineWidth = 1;
				}
			};
			drawGroup();
		}
	}
}

export default TaskGroup;
